import React from 'react';
import styled from 'styled-components';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import loadingAnimationLottie from '../../assets/Icon/lottie/loading-animation.lottie';

const LoadingWrapper = styled.div<{ $variant: 'centered' | 'content'; $marginTop?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${({ $marginTop }) => $marginTop ?? '0'};
  box-sizing: border-box;
  ${({ $variant }) =>
    $variant === 'centered'
      ? `
    /* 모바일 Main 등 부모에 확정 height 없을 때: 뷰포트 기준으로 세로 중앙 */
    min-height: calc(100dvh - 96px);
  `
      : `
    height: 100%;
    min-height: 0;
  `}
`;

const LottieWrapper = styled.div<{ $size: number; $reducePadding?: boolean }>`
  position: relative;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  overflow: ${({ $reducePadding }) => ($reducePadding ? 'hidden' : 'visible')};
`;

/** Lottie 내부 여백을 줄이기 위해 scale로 확대 (패딩이 포함된 lottie 파일 대응) */
const LottieInner = styled.div<{ $scale?: number }>`
  width: 100%;
  height: 100%;
  transform: ${({ $scale = 1 }) => `scale(${$scale})`};
  transform-origin: center center;
`;

interface DSLoadingProps {
  /** centered: 프로젝트 관리/나의 계정 등 전체 화면 중앙. content: 게시물/후원자/결제/프로젝트설정 웹 등 콘텐츠 영역 */
  variant?: 'centered' | 'content';
  /** Lottie 크기 (px). 기본값 317 */
  size?: number;
  /** margin-top 오버라이드 (예: '32px', '-40px') */
  marginTop?: string;
  /** @deprecated Lottie 사용 시 무시됨 */
  color?: string;
}

/** 페이지 이동 시 표시되는 로딩 (게시물 관리, 후원자 관리, 결제현황, 프로젝트 설정 등) */
const DSLoading: React.FC<DSLoadingProps> = ({ variant = 'centered', size, marginTop }) => {
  const resolvedSize = size ?? 317;
  const reducePadding = true;
  const resolvedMarginTop = marginTop ?? (variant === 'content' ? '-40px' : undefined);

  return (
    <LoadingWrapper $variant={variant} $marginTop={resolvedMarginTop}>
      <LottieWrapper $size={resolvedSize} $reducePadding={reducePadding}>
        <LottieInner $scale={reducePadding ? 1.35 : 1}>
          <DotLottieReact src={loadingAnimationLottie} autoplay loop style={{ width: '100%', height: '100%' }} />
        </LottieInner>
      </LottieWrapper>
    </LoadingWrapper>
  );
};

export default DSLoading;
